const IS_PROD =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("vercel.app") ||
    window.location.hostname.includes("doodates.com"));

export const PRODUCT_DOMAINS = {
  datePolls: "https://doo-dates-date-polls.vercel.app",
  formPolls: "https://doo-dates-form-polls.vercel.app",
  availability: "https://doo-dates-availability-polls.vercel.app",
  quizz: "https://doodates-quizz.vercel.app",
  recitation: "https://doodates-recitation.vercel.app",
};

export function getBaseUrl(): string {
  return import.meta.env.BASE_URL || "/";
}

export function buildUrl(path: string): string {
  const baseUrl = getBaseUrl();
  // S'assurer que le path ne commence pas par /
  const cleanPath = path.startsWith("/") ? path.substring(1) : path;
  return `${baseUrl}${cleanPath}`;
}

export function buildAbsoluteUrl(path: string): string {
  // En production, utiliser l'URL de production détectée automatiquement
  if (IS_PROD) {
    return `https://doodates.vercel.app${buildUrl(path)}`;
  }

  // En développement/local, utiliser window.location.origin ou localhost:8080
  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "http://localhost:8080";
  return `${origin}${buildUrl(path)}`;
}

export function buildPollUrl(pollId: string): string {
  return buildUrl(`poll/${pollId}`);
}

export function buildQuizzUrl(
  slug: string,
  action: "vote" | "results" = "vote",
): string {
  if (IS_PROD) return `${PRODUCT_DOMAINS.quizz}/quizz/${slug}/${action}`;
  return buildUrl(`quizz/${slug}/${action}`);
}

export function buildRecitationUrl(slug?: string): string {
  if (IS_PROD)
    return slug
      ? `${PRODUCT_DOMAINS.recitation}/recitation/${slug}`
      : PRODUCT_DOMAINS.recitation;
  return buildUrl(slug ? `recitation/${slug}` : "recitation");
}

export function buildAuthUrl(path: string): string {
  return buildUrl(`auth/${path}`);
}

export function buildDocsUrl(path: string): string {
  return buildUrl(`docs/${path}`);
}

export function buildApiUrl(path: string): string {
  return buildUrl(`api/${path}`);
}

export function navigateToUrl(path: string) {
  window.location.href = buildUrl(path);
}

export function navigateToAbsoluteUrl(path: string) {
  window.location.href = buildAbsoluteUrl(path);
}
